var c = Object.defineProperty;
var h = (e, t, i) => t in e ? c(e, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[t] = i;
var n = (e, t, i) => h(e, typeof t != "symbol" ? t + "" : t, i);
import { v4 as f } from "uuid";
const s = class s {
  /**
   * Private constructor to enforce singleton pattern.
   */
  constructor() {
    /**
     * Array containing current notifications with their IDs and open states.
     */
    n(this, "notifications", []);
    /**
     * Array of listener functions that subscribe to notifications changes.
     */
    n(this, "listeners", []);
  }
  /**
   * Retrieves the singleton instance of NotificationManager.
   * @returns The singleton instance of NotificationManager.
   */
  static getInstance() {
    return s.instance || (s.instance = new s()), s.instance;
  }
  /**
   * Adds a new notification to the manager.
   * Automatically generates an ID if not provided and sets it to open.
   * Notifies listeners of the new notification.
   * @param notification The notification object to add.
   */
  addNotification(t) {
    const i = t.id || f(), o = { ...t, id: i, open: !0 };
    this.notifications.push(o), this.notifyListeners(), setTimeout(() => {
      this.removeNotification(i);
    }, t.duration || 3e3);
  }
  /**
   * Removes a notification from the manager based on its ID.
   * Notifies listeners of the removal.
   * @param id The ID of the notification to remove.
   */
  removeNotification(t) {
    var i;
    this.notifications = (i = this == null ? void 0 : this.notifications) == null ? void 0 : i.filter((o) => o.id !== t), this.notifyListeners();
  }
  /**
   * Notifies all subscribed listeners of current notification updates.
   * This method triggers all registered listener functions.
   * @private
   */
  notifyListeners() {
    this.listeners.forEach((t) => t([...this.notifications]));
  }
  /**
   * Subscribes a listener function to receive notification updates.
   * @param listener The listener function to subscribe.
   */
  subscribe(t) {
    this.listeners.push(t);
  }
  /**
   * Unsubscribes a previously subscribed listener function.
   * @param listener The listener function to unsubscribe.
   */
  unsubscribe(t) {
    this.listeners = this.listeners.filter((i) => i !== t);
  }
};
/**
 * Singleton instance of NotificationManager.
 */
n(s, "instance");
let r = s;
export {
  r as NotificationManager
};
//# sourceMappingURL=index.es83.js.map
